//components
import { PillLink } from '@/containers-ai/Buttons';

//styles
import { EndCTASection, Title, TitleHighlight, Copy } from './EndCTA.styles';
import { Container } from '@/components/Grid';

export function EndCTA({ variant = 'top', content, id }) {
  return (
    <EndCTASection
      id={id ?? (variant === 'top' ? 'cta' : undefined)}
      $variant={variant}
    >
      <Container>
        <Title>
          {content.title}
          <TitleHighlight>{content.titleHighlight}</TitleHighlight>
        </Title>
        {content.copy && <Copy>{content.copy}</Copy>}
        <PillLink
          href={content.ctaHref ?? '/contact/#contact-form'}
          style={{ fontSize: '16px', padding: '16px 32px' }}
          className="qlf-btn-3"
          {...(content.external && {
            target: '_blank',
            rel: 'noreferrer noopener',
          })}
        >
          {content.ctaLabel}
        </PillLink>
      </Container>
    </EndCTASection>
  );
}
